<template>
  <div>
    <Tabbar :menuIndex="4" />
    <div class="top-banner">
      <div class="top-banner-title">数字勘察服务平台，深耕数字化服务</div>
      <div class="top-banner-content">让企业走在数字化前沿，实现快速发展</div>
      <div class="top-banner-btn" @click="$router.push('/application')">
        立即咨询
      </div>
    </div>
    <div class="layout">
      <h2 class="intro-title bold-text">
        <div>求实</div>
        <div>创新</div>
        <div>包容</div>
        <div>共享</div>
      </h2>
      <!-- <div class="sub-title">求实 • 创新 • 包容 • 共享</div> -->
      <p class="intro-content layout">
        弘扬“诚信服务，价值创造，创新引领，追求卓越”的核心价值观，坚持“为顾客创造价值”的经营理念、<br />“诚信
        • 感恩 • 责任 • 争先 •
        和谐”的团队理念，为工程建设全过程提供卓越服务，为“建设特色鲜明的国际化科技型工程公司”而努力奋斗！
      </p>
      <div class="map">
        <img src="@/assets/images/about/map.png" alt="" />
      </div>
      <div class="bannerBox" style="background-color: white;padding-bottom: 50px;">
        <div class="container" style="padding-bottom: 40px">
          <div class="title">
            <!-- <img src="@/assets/images/about/10.png" alt="" /> -->
            企业地址
          </div>
          <div class="swiper-container swiper-container1">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide1">
                <img src="@/assets/images/about/jidi1.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide1">
                <img src="@/assets/images/about/jidi2.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide1">
                <img src="@/assets/images/about/jidi3.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide1">
                <img src="@/assets/images/about/jidi4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bannerBox">
        <p
          class="intro-content layout"
          style="color: #000; margin-bottom: 100px;margin-top: 0;"
        >
          公司拥有国家住建部、发改委、测绘局、环境部、自然资源部、陕西省住建厅等颁发的工程勘察综合甲级，工程测绘甲级，建筑工程、市政工程<br />设计甲级，城乡规划和风景园林设计乙级，建筑工程、地基与基础工程、市政公用工程施工总承包壹级，地质灾害评估、勘查、设计、施工、监理甲级及建设项目环境影响评价乙级，环保工程、钢结构工程、机电工程、建筑机电安装工程专业承包三级，拥有建设工程质量检测机构（系原陕西省建设工程人工地基工程质量第一检测站）；通过了质量管理体系、环境管理体系、职业健康安全管理体系、信息技术服务管理体系及信息安全管理体系认证；能为业主提供与工程建设相关的策划咨询、规划设计、工程勘察、工程测绘、工程承包、工程检定及环境工程等全方位、全过程的服务
        </p>
        <div class="container" style="padding-bottom: 40px">
          <div class="title">
            <!-- <img src="@/assets/images/about/5.png" alt="" /> -->
            资质证书
          </div>
          <div class="swiper-container swiper-container2">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu1.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu2.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu3.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu4.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu5.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu6.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu7.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu8.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu9.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu10.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide2">
                <img src="@/assets/images/about/zhengshu11.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bannerBox rongyu"
        style="background-color: rgba(21, 2, 1, 0.06)"
      >
        <p
          class="intro-content layout"
          style="color: #181818; margin-bottom: 40px"
        >
          国家建设部、统计局、工商总局和陕西省委、省政府等授予“全国勘察设计综合实力百强单位”、“全国守合同重信用企业”、“全国安康杯竞赛优胜单位”、“全国先进工程勘察设计企业”、“全国优秀勘察设计院”、“全国行业“十佳自主技术创新企业”和“中央企业先进基层党组织”、“全国企业文化建设优秀单位”、“全国机械行业文明单位”、“陕西省文明单位”、“高新技术企业”等殊荣
        </p>
        <div class="container" style="padding-bottom: 40px">
          <div class="title">
            <!-- <img src="@/assets/images/about/600+.png" alt="" />项 -->
            专利及荣誉
          </div>
          <div class="swiper-container swiper-container3">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide3">
                <img src="@/assets/images/about/rongyu1.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide3">
                <img src="@/assets/images/about/rongyu2.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide3">
                <img src="@/assets/images/about/rongyu3.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide3">
                <img src="@/assets/images/about/rongyu4.png" alt="" />
              </div>
              <div class="swiper-slide swiper-slide3">
                <img src="@/assets/images/about/rongyu5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bannerBox" style="background-color: white;padding: 80px 0 100px;">
        <div class="container">
          <div class="title">知识产权</div>
          <div class="swiper-container swiper-container4">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz1.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz2.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz3.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz4.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz5.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz6.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz7.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz8.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz9.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz10.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz11.jpeg" alt="" />
              </div>
              <div class="swiper-slide swiper-slide4">
                <img src="@/assets/about/rz12.jpeg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Swiper from "@/components/Swiper/swiper.min.js";
import "@/components/Swiper/swiper.min.css";
export default {
  data() {
    return {
      bannerImg: require("@/assets/solution/pic_banner_gongchang.png"),
      titleActiveIndex: 0,
      dataList: [
        {
          introNum: "2022",
          introNumContent: "16年品牌沉淀",
        },
        {
          introNum: "13",
          introNumContent: "成功举办13届设计师大赛",
        },
        {
          introNum: "178400",
          introNumContent: "178400㎡制造基地",
        },
        {
          introNum: "100",
          introNumContent: "力争提供100分服务",
        },
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      new Swiper(".swiper-container1", {
        loop: true,
        centeredSlides: true,
        slidesPerView: 2.7,
        spaceBetween: 20,
      });
      new Swiper(".swiper-container2", {
        loop: true,
        slidesPerView: 4.5,
        spaceBetween: 40,
      });
      new Swiper(".swiper-container3", {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 50,
      });
      new Swiper(".swiper-container4", {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 50,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-banner {
  background-image: url("../assets/banner/6.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 500px;
  width: 100%;
  // margin-top: 76px;
  padding-top: 140px;
  text-align: left;
  position: relative;
  &-title {
    font-size: 48px;
    color: #fff;
    letter-spacing: 0;
    line-height: 72px;
    font-weight: 600;
    text-align: left;
    margin-left: 180px;
    position: absolute;
    top: 30%;
    left: 9.7%;
  }
  &-content {
    opacity: 0.8;
    font-size: 27px;
    color: #fff;
    letter-spacing: 0;
    line-height: 36px;
    margin-top: 20px;
    text-align: left;
    margin-left: 180px;
    position: absolute;
    top: 46%;
    left: 9.7%;
  }
  &-btn {
    display: inline-block;
    margin-top: 70px;
    border-radius: 20px;
    width: 178px;
    height: 40px;
    margin-right: 30px;
    color: white;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    background-image: linear-gradient(135deg, #1cffcd 0%, #2347ff 100%);
    margin-left: 180px;
    position: absolute;
    top: 62%;
    left: 9.7%;
    transition: all 0.3s;
    &:hover {
      background-image: linear-gradient(135deg, #00ffc8 0%, #002aff 100%);
    }
  }
}
.intro-title {
  font-size: 36px;
  margin-top: 80px;
  text-align: center;
  color: #181818;
  display: flex;
  justify-content: center;
  div {
    position: relative;
    & + div {
      margin-left: 60px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: -30px;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: rgb(97, 160, 254);
      }
    }
  }
}

.sub-title {
  margin-top: 0.64rem;
  font-size: 1.42rem;
  text-align: center;
  color: rgb(22, 120, 255);
  line-height: 2.28rem;
  position: relative;
}

.sub-title::after {
  content: "";
  width: 2.857rem;
  height: 0px;
  opacity: 1;
  border: 1px solid #002677;
  position: absolute;
  bottom: -1rem;
  left: 50%;
  transform: translateX(-50%);
}
.intro-content {
  font-size: 1rem;
  color: rgba(21, 2, 1, 0.6);
  margin: 60px auto 0;
  width: calc(100% - 100px);
  max-width: 75rem;
  padding: 0 4.5rem;
  box-sizing: border-box;
  text-align: center;
  line-height: 1.6;
}
.map {
  margin: 100px 0 50px;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
  &:hover img {
    transform: scale(1.1);
  }
  img {
    width: 100%;
    transition: all 0.5s;
  }
}
.bannerBox {
  padding: 40px 0 80px;
  .title {
    font-size: 42px;
    font-weight: 500;
    color: #150201;
    line-height: 1.4;
    position: relative;
    display: flex;
    align-items: flex-end;
    line-height: 1.6;
    margin-bottom: 4%;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -25px;
      width: 5px;
      height: 36px;
      background-image: linear-gradient(
        to top,
        rgb(153, 153, 253),
        rgb(99, 109, 253)
      );
    }
    img {
      height: 90px;
      width: auto;
    }
  }
}
.rongyu {
  // background-image: url("~@/assets/images/about/rongyu.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: linear-gradient(
    90deg,
    rgb(251, 252, 255),
    rgb(228, 234, 252) 75%,
    rgb(202, 222, 255)
  );
  .title {
    color: #181818;
  }
}
.history {
  // background-image: url("~@/assets/images/about/rongyu.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: rgb(22, 120, 255) !important;
  height: 500px;
  margin-top: 50px;
  .title {
    font-size: 40px;
    color: #fff;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 50px;
  }
  .list {
    position: relative;
    .line {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 1px;
      opacity: 1;
      border: 1px solid #fff;
    }
    .contentBox {
      width: 1280px;
      margin: 0 auto;
      position: relative;
      display: flex;
      justify-content: space-between;
      // &::before {
      //   cursor: pointer;
      //   content: "";
      //   width: 1.67vw;
      //   height: 1.67vw;
      //   background-image: url("~@/assets/images/about/prev.png");
      //   background-size: 100% 100%;
      //   background-repeat: no-repeat;
      //   position: absolute;
      //   z-index: 999;
      //   top: 50%;
      //   left: -6vw;
      //   transform: translateY(-50%);
      // }
      // &::after {
      //   cursor: pointer;
      //   content: "";
      //   width: 1.67vw;
      //   height: 1.67vw;
      //   background-image: url("~@/assets/images/about/next.png");
      //   background-size: 100% 100%;
      //   background-repeat: no-repeat;
      //   position: absolute;
      //   z-index: 999;
      //   top: 50%;
      //   right: -6vw;
      //   transform: translateY(-50%);
      // }
      .item {
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: 11vw;
        position: relative;
        padding-top: 2vw;
        .time {
          font-size: 1vw;
        }
        .content {
          font-size: 0.7vw;
        }
        .time,
        .content {
          color: inherit;
        }
        &::before {
          content: "";
          width: 0.5vw;
          height: 0.5vw;
          border-radius: 50%;
          background-color: #fff;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &::after {
          content: "";
          width: 1px;
          height: 2vw;
          background-color: #fff;
          position: absolute;
          top: 60%;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
.aiknow {
  font-size: 36px;
  font-weight: 500;
  color: #150201;
  text-align: center;
  margin: 80px 0 0 0;
}
.footer {
  img {
    width: 100%;
    height: auto;
  }
}
.swiper-slide1 {
  width: 466px;
  height: 240px;
  img {
    width: 100%;
    height: 100%;
  }
}
.swiper-slide2 {
  width: 350px;
  height: 180px;
  img {
    width: 100%;
    height: 100%;
  }
}
.swiper-slide3 {
  width: 210px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
  }
}
.swiper-slide4 {
  width: 210px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
